/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import EditableTextArea from 'DesignSystem/EditableTextArea/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/Preview/Html/Content",
  onChange
  
}) {
let contentValueData = fromData.useDataValue({ viewPath,
context: 'content',
})
let contentChangeData = fromData.useDataChange({ viewPath,
context: 'content',
})
let editorDisabledValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'disabled',
})
  return (<React.Fragment
>
<EditableTextArea
  viewPath={`${viewPath}/EditableTextArea`}
 data="content"
 value={contentValueData}
 onChange={contentChangeData}
 data="editor.disabled"
 disabled={editorDisabledValueData}
/>
{children}
</React.Fragment>)
}